import {ThemeType} from '../../../theme/types';
import {
  mapBorderToBaseProperties,
  mapFontToBaseProperties,
  mapPaddingToBaseProperties,
} from '../../themed/functions';
import {ThemePaddingPxProps} from '../../types';
import {InputLayoutMap} from '../styles';
import {BaseInputProps, InputProps} from '../types';
import {mapInputColorsToBaseProperties} from './mapInputColorsToBaseProperties';

export const mapInputToBaseProperties = (
  theme: ThemeType,
  props: InputProps,
): BaseInputProps => {
  const {
    state = 'Default',
    size = 'Default',
    leftIcon,
    rightIcon,
    leftSpinner,
    rightSpinner,
    leftText,
    rightText,
    leftAvatarUri,
    rightAvatarUri,
    secure,
  } = props;

  const left = !!leftIcon || leftSpinner || !!leftText || !!leftAvatarUri;
  const right = !!rightIcon || rightSpinner || !!rightText || !!rightAvatarUri;
  const inputLayout = InputLayoutMap[size];

  const padding: ThemePaddingPxProps = {
    paddingLeft: left ? inputLayout.enhanced.input.padding : undefined,
    paddingRight: right ? inputLayout.enhanced.input.padding : undefined,
  };

  return {
    ...mapFontToBaseProperties(theme, 'inline_14_default'),
    ...mapBorderToBaseProperties(theme, {
      borderStyle: 'none',
    }),
    ...mapPaddingToBaseProperties(theme, padding),

    ...mapInputColorsToBaseProperties(theme, props),

    flex: 1,
    disabled: state === 'Disabled',
    secure,
    // iconReversed: InputStyleMap[state].iconReversed,

    // hover: hover ? getExcitedPropVariants(theme, {backgroundColor}) : undefined,
  };
};
